import { useLocation, useNavigate } from 'react-router-dom';
import { FaArrowLeft, FaShieldHalved } from 'react-icons/fa6';

const AccessDenied = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const previousPath = location.state?.from || '/';

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="w-full max-w-lg text-center">
        <div className="flex justify-center mb-6">
          <div className="flex items-center justify-center w-20 h-20 rounded-full bg-red-100">
            <FaShieldHalved className="text-4xl text-red-500" />
          </div>
        </div>

        <p className="text-7xl font-bold text-[#1F2B68] mb-2">403</p>

        <h1 className="text-2xl md:text-3xl font-bold text-gray-800 mb-3">Acceso denegado</h1>

        <p className="text-gray-500 text-base md:text-lg leading-relaxed mb-8">
          No tienes los permisos necesarios para acceder a esta sección. Si consideras que deberías
          tener acceso, contacta con el administrador del sistema.
        </p>

        <button
          type="button"
onClick={() => navigate(-1)}          className="
                        inline-flex
                        items-center
                        justify-center
                        gap-2
                        px-6
                        py-3
                        rounded-lg
                        bg-[#1F2B68]
                        text-white
                        font-medium
                        shadow-sm
                        hover:bg-[#172052]
                        focus:outline-none
                        focus:ring-2
                        focus:ring-[#1F2B68]/30
                        transition-colors
                    "
        >
          <FaArrowLeft />
          Regresar
        </button>
      </div>
    </div>
  );
};

export default AccessDenied;
